import React, { useEffect } from "react";

const Privacy = () => {
  useEffect(() => {
    window.location.assign(
      "/privacy-policy.html"
    );
  });

  return <></>;
};

export default Privacy;
